import React from "react";
import { createStyles, makeStyles, Paper, Theme } from "@material-ui/core";
import { DictionaryConfigPaneHeader } from "./DictionaryConfigPaneHeader";
import { DictionaryConfigTable } from "./DictionaryConfigTable";
import { DictionaryConfigData } from "../../../../types/config";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    paper: {
      marginBottom: "0.5rem",
    },
  })
);

interface Props {
  // キー
  dictKey: string;
  onChangeExclusiveKey: (newExclusiveKey: string) => void;
  // データ
  data: DictionaryConfigData;
  onChangeData: (newData: DictionaryConfigData) => void;
  inputRef: React.RefObject<HTMLInputElement>;
  onChangeFile: (file: File | null) => void;
  // ヘッダー
  title: string;
  onInfo: () => any;
  onCreate: () => any;
  // エラー
  onError: (error: any) => void;
}

/** 辞書設定ペイン コンポーネント */
export function DictionaryConfigPane(props: Props) {
  const classes = useStyles();

  const {
    // キー
    dictKey,
    onChangeExclusiveKey,
    // データ
    data,
    onChangeData,
    inputRef,
    onChangeFile,
    // ヘッダー
    title,
    onInfo,
    onCreate,
    // エラー
    onError,
  } = props;

  //--------------------
  // レンダー行関数
  // 編集ボタン処理
  const handleEdit = () => {
    onChangeData({
      ...data,
      mode: "edit",
    });
    // 表示排他制御
    onChangeExclusiveKey(dictKey);
  };

  // 削除ボタン処理
  const handleDelete = () => {
    onChangeData({
      ...data,
      mode: "delete",
    });
    // 表示排他制御
    onChangeExclusiveKey(dictKey);
  };

  //--------------------
  // 編集行関数

  // 編集行 キャンセルボタン処理
  const handleEditingCanceled = () => {
    // DOMのファイルをクリア
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    // Stateのファイルをクリア
    onChangeData({
      ...data,
      mode: "render",
      file: null,
    });
  };

  // 編集行 保存ボタン処理
  const handleEditingApproved = () => {
    if (!data.file) {
      // ファイルが選択されていない場合は処理しない
      return;
    }
    // 処理状態をpendingに変更する
    onChangeData({
      ...data,
      status: "pending",
    });
  };

  //--------------------
  // 削除行関数

  // 削除行 キャンセルボタン押下
  const handleDeletingCanceled = () => {
    onChangeData({
      ...data,
      mode: "render",
    });
  };

  // 削除行 保存ボタン処理
  const handleDeletingApproved = () => {
    // 処理状態をpendingに変更する
    onChangeData({
      ...data,
      status: "pending",
    });
  };

  //--------------------
  // コンポーネント
  return (
    <Paper className={classes.paper}>
      {/* ヘッダー */}
      <DictionaryConfigPaneHeader
        data={data}
        title={title}
        onInfo={onInfo}
        onCreate={onCreate}
      />

      {/* テーブル */}
      <DictionaryConfigTable
        // キー
        dictKey={dictKey}
        // データ
        data={data}
        inputRef={inputRef}
        onChangeFile={onChangeFile}
        // レンダー行アクション
        onEdit={handleEdit}
        onDelete={handleDelete}
        // 編集行アクション
        onEditingApproved={handleEditingApproved}
        onEditingCanceled={handleEditingCanceled}
        // 削除行アクション
        onDeletingApproved={handleDeletingApproved}
        onDeletingCanceled={handleDeletingCanceled}
        // エラー
        onError={onError}
      />
    </Paper>
  );
}
